__turbopack_context__.v({
  "disabled": "RadioInput-module-scss-module__fc3Kca__disabled",
  "fullWidth": "RadioInput-module-scss-module__fc3Kca__fullWidth",
  "wrapper": "RadioInput-module-scss-module__fc3Kca__wrapper",
});
